import { branchRole } from "../../shared/branchRole";

export function blockedBySelfMerge(
  workflow:
    | {
        space?: { blockSelfApproval: boolean | null } | null;
        autofixBranchId: string | null;
        autoImproveBranchId: string | null;
      }
    | undefined,
  branch:
    | {
        id: string;
        userId: string | null;
        contributors: readonly { userId: string }[];
      }
    | undefined,
  userId: string
) {
  return Boolean(
    workflow?.space?.blockSelfApproval &&
    ((branch?.userId === userId &&
      branchRole({ id: branch.id, workflow }) === "other") ||
      branch?.contributors.some((c) => c.userId === userId))
  );
}
